import { LineItemDistributionDetail } from '../LineItemDistributionDetail'
import { CMS1500DiagnosisDto } from '../claim/CMS1500DiagnosisDto'

export interface IBilloutRequest {
  lineItemDistributionDetails: LineItemDistributionDetail[]
  diagnosisCodes: CMS1500DiagnosisDto[]
  fullUsualAndCustomaryBillout?: boolean
}

export class BilloutRequest implements IBilloutRequest {
  public lineItemDistributionDetails: LineItemDistributionDetail[]
  public diagnosisCodes: CMS1500DiagnosisDto[]
  public fullUsualAndCustomaryBillout?: boolean
}
